import IconArrowRight from '../../../../assets/icons/IconArrowRight';
import { colors } from '../../../../styles/Colors';
import {
  TextBold,
  TextMedium,
} from '../../../../styles/GlobalStyledComponents';
import { pricesHelper } from '../../../../utils/paymentsHelper';
import { InfoCardMiniSpan, CardLabel } from '../../../CardInputs/CardsStyledComponents';
import {
  CardColumn,
  CardColumnArrow,
  CardContainer,
  CardRow,
  CardSectionColumn,
} from './LoanCardStyledComponents';

interface LoanCardProps {
  loanId: string;
  loanReference: number;
  debtAmount: number;
  paymentPlan?: boolean;
  onClick?: () => void;
}

const LoanCard: React.FC<LoanCardProps> = ({
  loanId,
  loanReference,
  debtAmount,
  paymentPlan,
  onClick,
}) => {
  return (
    <CardContainer id="loan-card-container" onClick={onClick} key={loanId}>
      <CardColumn id="loan-card-column">
        <CardRow id="loan-card-row">
          <CardSectionColumn id="loan-card-column-info">
            <TextBold id="loan-card-text-bold" fontSize={16} lineHeight={22}>
              Operación: {loanReference}
            </TextBold>
            <p>
              <TextMedium
                id="loan-card-text-medium"
                fontSize={14}
                lineHeight={20}
              >
                Accede a opciones disponibles para resolver tu deuda{' '}
              </TextMedium>
            </p>
          </CardSectionColumn>
          <CardColumnArrow id="loan-card-column-arrow">
            <IconArrowRight />
          </CardColumnArrow>
        </CardRow>
        <CardRow id="loan-card-row-amount">
          <TextBold id="loan-card-text-bold" fontSize={16} lineHeight={22}>
            {debtAmount && pricesHelper(debtAmount)} €
          </TextBold>
          {paymentPlan && (
            <InfoCardMiniSpan
              backgroundColor={colors.yellow10}
              id="loan-card-info-text"
            >
              <CardLabel fontSize={14} lineHeight={16}>
                Acuerdo vigente
              </CardLabel>
            </InfoCardMiniSpan>
          )}
        </CardRow>
      </CardColumn>
    </CardContainer>
  );
};

export default LoanCard;
